import { DOCS_URL } from "../../../config/constants.js";
import FeaturedItems from "./FeaturedItems.svelte";

export default {
    component: FeaturedItems,
    name: "Featured Items",
    description: "Grid of featured content items with images and text",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-featureditems--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/tag-starred.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F979ae9b12af54792ac82f4c34003c510",
    inputs: [
        {
            friendlyName: "Header",
            name: "header",
            type: "longText",
        },
        {
            friendlyName: "CTA To",
            name: "ctaTo",
            type: "text",
        },
        {
            friendlyName: "CTA Text",
            name: "ctaText",
            type: "text",
        },
        {
            friendlyName: "Features",
            name: "features",
            type: "list",
            subFields: [
                {
                    friendlyName: "Featured Image",
                    name: "image",
                    type: "object",
                    helperText: "16:9 Aspect Ratio",
                    subFields: [
                        {
                            friendlyName: "Source",
                            name: "src",
                            type: "file",
                            allowedFileTypes: ["jpg", "webm", "gif", "png"],
                            defaultValue: "https://placehold.co/1280x720",
                        },
                        {
                            friendlyName: "Alt",
                            name: "alt",
                            type: "text",
                        },
                    ],
                },
                {
                    friendlyName: "Featured Text",
                    name: "featuredText",
                    type: "longText",
                },
                {
                    friendlyName: "Link To",
                    name: "linkTo",
                    type: "text",
                },
            ],
        },
    ],
};
